module.exports = __webpack_public_path__ + "img/vkontake_colored.a01a4920.svg";